import { Badge, cn } from "@rarible_int/anaconda_ui_components"

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  count?: number
}

export const countFormatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
})

export function CounterBadge({ count, className, ...props }: Props) {
  if (!count) return null

  return (
    <Badge
      className={cn("pt-0 pb-[2px] text-inherit transition-none", className)}
      variant="secondary"
      {...props}
    >
      {countFormatter.format(count)}
    </Badge>
  )
}
